import { PREFIX_PRODUCER } from "@/api/Model/ProductOwnerModel";
import AbstractProduct from "../Product";

class Product extends AbstractProduct {
  static getResourceEndpoint() {
    return PREFIX_PRODUCER + '/products-ipr';
  }
}

export default Product;
